<div class="graficos entidades-inproeco">
  <div class="fila-graficos1">
    <div class="chart-inicio">
      <h2 [routerLink]="['/inproeco/estado/pendientes']">{{ title_documentos }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasDocumentos  class="chartjs-render-monitor" (click)="showDataDocumentos($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio">
      <h2 [routerLink]="['/inproeco/estado/instalaciones']">{{ title_instalaciones }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasInstalaciones class="chartjs-render-monitor" (click)="showDataInstalaciones($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/inproeco/estado/centros']">{{ title_centros }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasCentros class="chartjs-render-monitor" (click)="showDataCentros($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/inproeco/estado/clientes']">{{ title_clientes }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasClientes class="chartjs-render-monitor" (click)="showDataClientes($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fila-graficos2">
    <div class="chart-inicio">
      <h2  [routerLink]="['/inproeco/estado/contratistas']">{{ title_contratistas }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasContratistas class="chartjs-render-monitor" (click)="showDataContratistas($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/inproeco/estado/gestores']">{{ title_gestores }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasGestores class="chartjs-render-monitor" (click)="showDataGestores($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio">
      <h2 [routerLink]="['/inproeco/estado/transportistas']">{{ title_transportistas }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasTransportistas class="chartjs-render-monitor" (click)="showDataTransportistas($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p>
  <!--  <canvas #canvasNetWorth>{{ chart }}</canvas> -->
</p>
